// 页面权限
export const BANNER_LIST_PAGE_UUID = '11696988-f9b2-4268-9d1b-1ecaa89af10f'
// 操作权限
export const BANNER_ACTION_UUID = 'b2050008-403c-4ccd-a05a-136de1278533'
